import React from 'react';
import '../../pages/terms-and-condition/index.scss';

import AccountSubSecTitle from '../../components/accout-subsec-title';
import Footer from '../footer';
import MobileFooter from '../mob-footer';

const TermsAndConditionsLayout = ({
  isSeparatePage,
  theme,
  mobileFooterClickHandler,
  activeKey,
  isMobileScreen,
  isAccountScreen,
  children,
  goBackOnClick,
  title = 'Terms & Conditions'
}) => {
  return (
    <>
      <div
        className={`terms-pg_wrapper ${isSeparatePage ? 'terms-pg_full' : ''}`}
      >
        {isSeparatePage ? (
          ''
        ) : (
          <AccountSubSecTitle
            title={title}
            goBackOnClick={goBackOnClick}
            theme={theme}
          />
        )}
        <div className="terms-pg">
          {isSeparatePage ? (
            <AccountSubSecTitle title={title} goBackOnClick={goBackOnClick} />
          ) : (
            ''
          )}
          {children}
        </div>
        {isSeparatePage ? <Footer /> : ''}
      </div>
      <div className="u_mobile-footer">
        {isMobileScreen && !isAccountScreen && (
          <MobileFooter
            activeKey={activeKey}
            mobileFooterClick={mobileFooterClickHandler}
            theme={theme}
          />
        )}
      </div>
    </>
  );
};

export default TermsAndConditionsLayout;
